import styled from 'styled-components';

export const PostPageWrapper = styled.div`
  article {
    padding: 0 16px 14px;
  }
`;
